<article class="ade-artigo" *ngIf="article && !isLoading">
  <div
    class="ade-artigo__hero"
    *ngIf="a.useFeatureImageOnDetail && a.featureImage?.data"
  >
    <Image
      [src]="featureImgUrl(a.featureImage.data.attributes.url)"
      [bigSrc]="featureImgUrl(a.featureImage.data.attributes.url)"
      [alt]="a.title"
      [full]="false"
    ></Image>
  </div>
  <div class="ade-artigo__body">
    <h1 class="ade-artigo__title">{{ a.title }}</h1>
    <p class="ade-artigo__date" *ngIf="a.publishDate">
      {{ a.publishDate | date: "d MMMM yyyy" }}
    </p>
    <ng-container *ngFor="let widget of a.layout">
      <ng-container [ngSwitch]="widget?.__component">
        <div
          *ngSwitchCase="'widgets.editor-text'"
          class="ade-artigo__text"
          [innerHTML]="widget.body"
        ></div>
        <div
          *ngSwitchCase="'shared.text'"
          class="ade-artigo__text"
          [style.text-align]="widget.textAlign || 'left'"
          [innerHTML]="widget.body"
        ></div>
        <div *ngSwitchCase="'widgets.image'">
          <widget-image [widget]="widget"></widget-image>
        </div>
        <div *ngSwitchCase="'widgets.gallery'">
          <widget-gallery [widget]="widget"></widget-gallery>
        </div>
        <div *ngSwitchCase="'widgets.video'">
          <widget-video [widget]="widget"></widget-video>
        </div>
        <div *ngSwitchCase="'widgets.banner'">
          <widget-banner [widget]="[widget]"></widget-banner>
        </div>
        <div *ngSwitchCase="'widgets.block-title-description'">
          <widget-block-title-description
            [widget]="widget"
          ></widget-block-title-description>
        </div>
      </ng-container>
    </ng-container>
  </div>
</article>
<div class="ade-loading" *ngIf="isLoading">
  <mat-spinner diameter="40"></mat-spinner>
</div>
